/**
*   配置文件
*/

// 图标库图标
import {
    AppstoreOutlined,
    SettingOutlined,
    CustomerServiceOutlined,
} from '@ant-design/icons';

// 自定义图标
import {
    StartIcon,
    EndIcon,
    LLMIcon,
    MCPIcon,
    APIIcon,
    LogIcon,
    ContentCreationIcon,
} from './Icons';

const CNF = {
    api: process.env.REACT_APP_API,
    onaiApi: process.env.REACT_APP_ONAI_API,
    xmcpApi: process.env.REACT_APP_XMCP_API,
    cfmsApi: process.env.REACT_APP_CFMS_API,
    ossApi: process.env.REACT_APP_OSS_API,
    projectCode: 'XINY',
    projectName: 'XinYuanChat',
    projectShortName: '新致腾·新元',             // 项目简称
    projectFullName: '新元大模型应用服务平台',     // 项目全称
    version: '1.0.0',
    mainUrl: '',                                // 主页地址
    homeUrl: process.env.REACT_APP_HOME_URL,    // 首页地址
    loginUrl: process.env.REACT_APP_LOGIN_URL,  // 登录地址
    userUrl: process.env.REACT_APP_USER_URL,    // 设置地址
    companyShortName: '新致腾',                  // 公司简称
    locale: 'zhCN',                             // 国际化语言
    safetyColor: '#308014',                     // 安全颜色
    warningColor: '#FAAD13',                    // 警告颜色
    dangerColor: '#FF0000',                     // 危险颜色

    isDisplayTableBorder: 0,                    // 是否显示表格边框
    cookies: {
        keySecure: true,
        keyPath: '/',
        keyDomain: process.env.REACT_APP_COOKIE_DOMAIN,
        keyExpire: 2592000,
        keyUid: 'login_xzt_uid',
        keyId: 'login_xzt_id',
        keyToken: 'login_xzt_token',
        keyUsername: 'login_xzt_username',
        keyDisplayname: 'login_xzt_displayname',
        keyAvatarUrl: 'login_xzt_avatar_url',
        keyThemeColor: 'login_xzt_theme_color',
        keyIsDisplayTableBorder: 'login_xzt_is_display_table_border',
    },

    themeColors: [    //可选主题颜色
        '#fa541c',
        '#1677ff',
        '#13c2c2',
        '#722ed1',
        '#fa8c16',
        '#f5222d',
        '#52c41a',
        '#eb2f96',
        '#a0d911',
        '#faad14',
    ],

    baseBgColor: '#F9FAFD',                // 基础背景色         
    baseBgActiveColor: '#F0F1F5',          // 基础背景色（active）
    baseBorderSolidColor: '#E7E8EF',       // 基础边框颜色
    baseTextColor: '#26244ce0',            // 基础字体颜色
    basePlaceholderColor: '#9D9DAF',       // 基础输入框提示文字颜色
    basePadding: 18,                       // 基础默认内边距   

    timeout: 5000,
    tDivisor: 9999999999,
    maxAge: 3600,
    fontSizeXS: 10,
    fontSizeSM: 12,
    fontSize: 14,                          // 字体大小
    fontSizeLG: 16,
    fontSizeXL: 20,
    menuHeight: 64,                        // 菜单栏高度
    menuLineHeight: 64,                    // 菜单栏行高
    contentHeaderHeight: 64,               // 内容页标题栏高度
    messageDuration: 1.5,                  // 消息弹框持续时间，单位秒
    animateDuration: 2000,                 // 动画持续时间，单位秒
    screenWidth: 1440,                     // 系统屏幕宽度
    searchMarginLeft: 5,                   // 搜索栏左边距
    rowMarginTop: 10,                      // 行距顶部高度
    lineHeight: 2.2,                       // 行高
    tableOperationColumnWidth: 80,         // 表格操作者列宽度
    tableStatusColumnWidth: 80,            // 表格状态列宽度
    tableCreateTimeColumnWidth: 120,       // 表格创建时间列宽度
    tableCreateDisplayeColumnWidth: 90,    // 表格创建者列宽度
    maxPageSize: 65535,                    //  最大分页数，主要用于下拉列表
    pageSize: 10,
    DPL: 2,                                // 小数点长度（Decimal Point Length）
    BOOLEAN_TRUE: 1,                       // 布尔值真
    APP_CONFIG_SPLIT: '_____APP_CONFIG_SPLIT_____',     // 应用配置分割符
    swatches: {   // 色板
        default: ['#1983FF', '#07C9CA', '#F0884D', '#D580FF', '#7963FF', '#BD8F25', '#60C42E', '#FF80CA', '#2492B3', '#18C86F'],
    },
    currentSwatche: 'default', // 当前色板
    status: [
        { label: '激活', value: '激活' },
        { label: '禁用', value: '禁用' },
    ],
    booleanSelectOptions: [
        { label: '否', value: 0 },
        { label: '是', value: 1 },
    ],
    navItems: [
        {
            url: '/admin/appinfos', icon: <AppstoreOutlined />, m: 1, name: '应用管理', ptn: 'btn_xiny_admin_appinfo', sub: 'sub1', submenu: [
                { url: '/admin/appinfos', name: '应用信息管理', icon: '', m: 11, ptn: 'btn_xiny_admin_appinfo', isLogModule: true },
            ]
        },
        {
            url: '/admin/log/operations', icon: <LogIcon />, m: 2, name: '日志管理', ptn: 'btn_xiny_admin_log', sub: 'sub2', submenu: [
                { url: '/admin/log/operations', name: '操作日志管理', icon: '', m: 21, ptn: 'btn_xiny_admin_log_operation' },
            ]
        }
    ],
    menuItems: [
        {
            uri: '/app', mn: 1, name: '应用', icon: '', ptn: 'btn_xiny_app', submenu: [
                { uri: '/app/appMarket', mn: 11, name: '应用广场', icon: <AppstoreOutlined />, ptn: 'btn_xiny_app_market', },
                { uri: '/app/appManagement', mn: 12, name: '应用管理', icon: <SettingOutlined />, ptn: 'btn_xiny_app_management', },
            ]
        },
    ],
    appIcon: 'https://img.alicdn.com/imgextra/i2/O1CN019ZvLMo29k9EDqAN7l_!!6000000008105-2-tps-1024-1024.png',  // 应用默认图标
    nodeConfig: {
        start: {
            key: 'Start',
            nodeType: '开始',
            icon: <StartIcon />,
            theme: '#3c8618',
            title: '开始',
            input: {
                sys: {
                    query: '',
                },
                user: {
                }
            }
        },
        end: {
            key: 'End',
            nodeType: '结束',
            icon: <EndIcon />,
            theme: '#f5222d',
            title: '结束',
            output: {
                result: '',
            }
        },
        llm: {
            key: 'LLM',
            nodeType: '大模型',
            icon: <LLMIcon />,
            theme: '#fa541c',
            title: '大模型',
            input: {
                system_prompt: '',
                user_prompt: '',
            },
            output: {
                result: '',
                reasoning_content: '',
            }
        },
        mcp: {
            key: 'MCP',
            nodeType: 'MCP',
            icon: <MCPIcon />,
            theme: '#8080FF',
            title: 'MCP',
            output: {
                result: '',
            }
        },
        api: {
            key: 'API',
            nodeType: 'API',
            icon: <APIIcon />,
            theme: '#14C2C2',
            title: 'API',
            output: {
                result: '',
            }
        },
    },
    runStatus: {
        RUNNING: '执行中',
        SUCCESS: '执行成功',
        STOP: '执行终止',
        ERROR: '执行错误',
    },
    releaseStatus: {
        NOT: '未发布',
        DONE: '已发布',
    },
    WORKFLOW: '工作流',
    AGENT: '智能体',
    actionName: { // 动作名称
        CREATE: '新增',
        UPDATE: '修改',
        ACTIVE: '激活',
        DISABLE: '禁用',
        DELETE: '删除',
    },
    models: [
        {
            label: '月之暗面·moonshot',
            name: 'moonshot',
            logo: 'https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/logos/logo-kimi.png',
            versions: [
                { label: 'moonshot-v1-auto', value: 'moonshot-v1-auto', temperature: 0.3, top_p: 1.0, max_tokens: 8, },
                { label: 'kimi-latest', value: 'kimi-latest', temperature: 0.3, top_p: 1.0, max_tokens: 8, },
                { label: 'kimi-k2-thinking', value: 'kimi-k2-thinking', temperature: 0.3, top_p: 1.0, max_tokens: 256, },
                { label: 'kimi-k2-thinking-turbo', value: 'kimi-k2-thinking-turbo', temperature: 0.3, top_p: 1.0, max_tokens: 256, },
                { label: 'kimi-k2-turbo-preview', value: 'kimi-k2-turbo-preview', temperature: 0.3, top_p: 1.0, max_tokens: 256, },
            ]
        },
        {
            label: '深度求索·deepseek',
            name: 'deepseek',
            logo: 'https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/logos/deepseek.png',
            versions: [
                { label: 'deepseek-chat', value: 'deepseek-chat', temperature: 1.3, top_p: 0.7, max_tokens: 4, },
                { label: 'deepseek-reasoner', value: 'deepseek-reasoner', temperature: 1.3, top_p: 0.7, max_tokens: 4, },
            ],
        },
        {
            label: '阿里·通义千问',
            name: '通义千问',
            logo: 'https://juhecdn.oss-cn-hangzhou.aliyuncs.com/chat/logo-tongyi@2x.png',
            versions: [
                { label: 'qwen-turbo', value: 'qwen-turbo', temperature: 0.8, top_p: 0.8, max_tokens: 16, },
                { label: 'qwen-plus', value: 'qwen-plus', temperature: 0.8, top_p: 0.8, max_tokens: 32, },
                { label: 'qwen-max', value: 'qwen-max', temperature: 0.8, top_p: 0.8, max_tokens: 8, },
                { label: 'qwen3-max', value: 'qwen3-max', temperature: 0.8, top_p: 0.8, max_tokens: 64, },
            ]
        }
    ],
    appFileds: [
        {
            label: '企服',
            value: '企服',
            icon: <CustomerServiceOutlined />
        },
        {
            label: '内容创作',
            value: '内容创作',
            icon: <ContentCreationIcon />
        }
    ],
    apiTypes: ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
    referenceMethods: ['输入', '引用'],
    variableTypes: [
        'string',
        'number',
        'array',
        // 'boolean',
        // 'object',
    ],
    displayFormats: ['Json', 'Text', 'Markdown'],
    exportFormats: ['PDF', 'WORD'],
}

export default CNF;